import { render, staticRenderFns } from "./TypeoperationsShow_Headers.vue?vue&type=template&id=d8e4fe2c&"
import script from "./TypeoperationsShow_Headers.vue?vue&type=script&lang=js&"
export * from "./TypeoperationsShow_Headers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports